import axios from "axios";
import { api } from "roboflex-thalamus-request-handler";

/** Base da API Laravel (`/api`). Fallback local se o mode do Vue CLI não carregou o .env. */
function resolveApiBaseUrl() {
  const fromEnv = (process.env.VUE_APP_ROOT_API || "").trim();
  if (fromEnv) {
    return fromEnv.replace(/\/$/, "");
  }
  if (process.env.NODE_ENV === "development") {
    return "http://127.0.0.1:8000/api";
  }
  return "/api";
}

/**
 * GET salas-reuniao/eventos?google_calendar_id=&nome=&inicio=&fim=
 * (autenticado via SSO — uso administrativo)
 * @param {string} googleCalendarId ID do calendário Google (ex.: e-mail do recurso)
 * @param {string} nomeSala Nome exibido na tela
 * @param {string} inicioIso
 * @param {string} fimIso
 */
export function eventosPorCalendario(googleCalendarId, nomeSala, inicioIso, fimIso) {
  return api
    .get("salas-reuniao/eventos", {
      params: {
        google_calendar_id: googleCalendarId,
        nome: nomeSala || "",
        inicio: inicioIso,
        fim: fimIso,
      },
    })
    .then((res) => res.data);
}

/**
 * GET salas-reuniao/porta/eventos?token=&inicio=&fim=
 * Display na porta — sem JWT; autentica só pelo token do display.
 * @param {string} displayToken
 * @param {string} inicioIso
 * @param {string} fimIso
 */
export function eventosPortaPorToken(displayToken, inicioIso, fimIso) {
  return axios
    .get("salas-reuniao/porta/eventos", {
      baseURL: resolveApiBaseUrl(),
      params: {
        token: displayToken,
        inicio: inicioIso,
        fim: fimIso,
      },
    })
    .then((res) => res.data);
}

/**
 * GET salas-reuniao/publico
 * Mosaico da TV — sem JWT e sem token. Lista as salas ativas e os eventos do dia.
 */
export function eventosMosaicoPublico() {
  return axios
    .get("salas-reuniao/publico", {
      baseURL: resolveApiBaseUrl(),
    })
    .then((res) => res.data);
}

/** URL OAuth Google (abrir em window.location). */
export function obterUrlRedirectGoogleCalendar() {
  return api.get("google/calendar/redirect-url").then((res) => res.data?.redirect_url ?? "");
}
